export default __webpack_public_path__ + "ed1d7ac186f117a8c3d6f759b50b8b93.webp";